const _ = require('./enum');

module.exports = {
  [_.AUTHENTICATION]: { id: _.AUTHENTICATION, label: 'Authentication' },
  [_.PAYIN]: { id: _.PAYIN, label: 'Payin' },
  [_.PAYOUT]: { id: _.PAYOUT, label: 'Payout' },
  [_.RISK_ASSESSMENT]: { id: _.RISK_ASSESSMENT, label: 'Risk assessment' },
};
